"use strict";

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/es.weak-map.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTranslationsContext = exports.TranslationsContextProvider = void 0;

var _react = _interopRequireWildcard(require("react"));

var _webShellClientReact = require("@nike/web-shell-client-react");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * @name TranslationsContext
 * @description Translations Context
 * @returns {React.Context<ContextProps>}
 * @memberof privacy-shared-logic
 */
var TranslationsContext = /*#__PURE__*/(0, _react.createContext)(undefined);
/**
 * @name useTranslationsContext
 * @description A custom hook which returns a context or throw an error if it is not exist.
 * @returns {ContextProps}
 * @memberof privacy-shared-logic
 */

var useTranslationsContext = function useTranslationsContext() {
  var context = (0, _react.useContext)(TranslationsContext);

  if (context === undefined) {
    throw new Error('useTranslationsContext must be used within TranslationsContextProvider');
  }

  return context;
};

exports.useTranslationsContext = useTranslationsContext;

/**
 * @name TranslationsContextProvider
 * @description Translations Provider for shared components
 * @param {Object} props - The props object
 * @param {string} props.namespace - The namespace of the specific values or the name of the project in Bodega.
 * @param {ReactNode} props.children
 * @returns {JSX.Element}
 * @memberof privacy-shared-logic
 */
var TranslationsContextProvider = function TranslationsContextProvider(_ref) {
  var namespace = _ref.namespace,
      children = _ref.children;
  var translations = (0, _webShellClientReact.useTranslations)([namespace]);
  var value = {
    getMessage: translations.getMessage,
    formatMessage: translations.formatMessage,
    isReady: translations.isReady
  };
  return /*#__PURE__*/_react.default.createElement(TranslationsContext.Provider, {
    value: value
  }, children);
};

exports.TranslationsContextProvider = TranslationsContextProvider;